import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { TNavigationStackWithParams } from 'app/types';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import DrugIntakeFlow from "../components/activity/flow/DrugIntakeFlow"
import { ActivityName } from '../types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { TActivityBucket } from '../utils/activityCard';

const DrugIntakeFlowScreen = () => {
    const route = useRoute<RouteProp<TNavigationStackWithParams<{ activityName: ActivityName, activityId: string, initialStep: number, bucket: TActivityBucket }>, 'ActivitySubmit'>>();
    const navigation = useNavigation<NativeStackNavigationProp<TNavigationStackWithParams<undefined>>>();

    const activityName = route.params?.activityName;
    const initialStep = route.params?.initialStep || 0;
    const activityId = route.params?.activityId;
    const bucket = route.params?.bucket;

    const handleGoToHome = () => {
        navigation.navigate("Homepage");
    }

    return (
        <MainLayout navigation={handleGoToHome}>
            <DrugIntakeFlow activityName={activityName} activityId={activityId} initialStep={initialStep} bucket={bucket} />
        </MainLayout>
    );
};

export default DrugIntakeFlowScreen;